// extracted by mini-css-extract-plugin
export default {"pdfWrapper":"pdfRenderer_pdfWrapper__Qs6sS"};